<template>
  <div class="preika-auth-page">
    <div class="preika-auth-shell">
      <section class="preika-auth-brand">
        <img
          src="/img/avatars/preika_black.png"
          alt="PREIKA"
          class="preika-auth-brand__logo"
        >

        <div class="preika-auth-brand__content">
          <p class="preika-auth-brand__eyebrow">SECURE PASSWORD</p>
          <h1>新しいパスワードを<br>設定してください。</h1>
          <p>
            英数字を組み合わせた8文字以上20文字以下のパスワードを設定します。
            他サービスで使用しているパスワードの使い回しは避けてください。
          </p>
        </div>
      </section>

      <section class="preika-auth-form">
        <p class="preika-auth-form__eyebrow">RESET PASSWORD</p>
        <h2>新しいパスワード</h2>
        <p class="preika-auth-form__description">
          確認のため、同じパスワードを2回入力してください。
        </p>

        <ValidationObserver ref="obs" v-slot="observerProps">
          <CForm @submit.prevent="changePassword">
            <div
              v-if="errors.length"
              class="alert alert-danger"
              role="alert"
            >
              <div v-for="error in errors" :key="error">
                {{ error }}
              </div>
            </div>

            <ValidationProvider
              name="新しいパスワード"
              rules="required|password"
              v-slot="providerProps"
            >
              <label for="preika-new-password">
                新しいパスワード
                <span class="asterisk">*</span>
              </label>
              <CInput
                id="preika-new-password"
                :type="passwordInputType"
                v-model="newPassword"
                autocomplete="new-password"
                description="英数字混在で8文字以上20文字以下。記号も入力できます。"
                :is-valid="providerProps.errors.length ? false : null"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked"/>
                </template>
              </CInput>
              <p v-if="providerProps.errors[0]" class="error">
                {{ providerProps.errors[0] }}
              </p>
            </ValidationProvider>

            <ValidationProvider
              name="新しいパスワード(確認)"
              rules="required|password|check:新しいパスワード"
              v-slot="providerProps"
            >
              <label for="preika-confirm-password">
                新しいパスワード（確認）
                <span class="asterisk">*</span>
              </label>
              <CInput
                id="preika-confirm-password"
                :type="passwordInputType"
                v-model="confirmPassword"
                autocomplete="new-password"
                :is-valid="providerProps.errors.length ? false : null"
              >
                <template #prepend-content>
                  <CIcon name="cil-lock-locked"/>
                </template>
              </CInput>
              <p v-if="providerProps.errors[0]" class="error">
                {{ providerProps.errors[0] }}
              </p>
            </ValidationProvider>

            <label class="preika-password-visibility">
              <input type="checkbox" v-model="showPassword">
              <span>入力したパスワードを表示</span>
            </label>

            <div class="preika-auth-form__actions preika-auth-form__actions--end">
              <save-button
                label="パスワードを変更"
                loading-label="変更中"
                :loading="loading"
                :disabled="observerProps.invalid || !observerProps.validated"
                @click="changePassword"
              />
            </div>
          </CForm>
        </ValidationObserver>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import ConstList from './../../ConstList'
import SaveButton from '../../common/SaveButton'

export default {
  name: 'ResetPassword',

  components: {
    SaveButton
  },

  props: {
    id: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      newPassword: '',
      confirmPassword: '',
      showPassword: false,
      loading: false,
      errors: []
    }
  },

  computed: {
    passwordInputType () {
      return this.showPassword ? 'text' : 'password'
    }
  },

  methods: {
    changePassword () {
      if (this.loading) return

      this.loading = true
      this.errors = []

      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/password/reset', {
          id: this.id,
          token: this.token,
          password: this.newPassword
        })
        .then(response => {
          if (response.data === ConstList.SUCCESS) {
            this.$router.push({ name: 'ResetComplete' })
            return
          }

          this.errors.push('パスワードの再設定に失敗しました。')
        })
        .catch(error => {
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + '/error/frontError',
              { error: String(error) },
              {
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.preika-password-visibility {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  color: var(--preika-text-secondary);
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
}

.preika-auth-form__actions--end {
  justify-content: flex-end;
  margin-top: 24px;
}
</style>
